import { render, staticRenderFns } from "./kabala-userheader.vue?vue&type=template&id=72170d80&scoped=true&"
import script from "./kabala-userheader.vue?vue&type=script&lang=js&"
export * from "./kabala-userheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72170d80",
  null
  
)

export default component.exports